// =============================================================================
// state
// =============================================================================
const state = {
  infoList: [],
  selectIndex: -1
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  info_ist: state => state.infoList,
  select_index: state => state.selectIndex,
  select_indo_data: state => {
    if (state.selectIndex === -1) {
      return null;
    }
    return state.infoList[state.selectIndex];
  }
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_info (state, value) {
    state.infoList = value;
  },
  set_select_index (state, value) {
    state.selectIndex = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
